import * as actions from './email-template.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { EmailMessageTemplateModel } from '@smarttask-common/src/lib/models/Integrations/Email/EmailMessageTemplateModel';

export const templateAdapter = createEntityAdapter<EmailMessageTemplateModel>({
    selectId: (x) => x.template_id,
});
export interface EmailMessageTemplateState extends EntityState<EmailMessageTemplateModel> {
    selected_template_id: string;
}

export const initialState: EmailMessageTemplateState = templateAdapter.getInitialState({
    selected_template_id: undefined,
});

export function EmailMessageTemplateReducers(state: EmailMessageTemplateState = initialState, action: actions.EmailMessageTemplateActions) {
    switch (action.type) {
        case actions.EmailMessageTemplateActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_template_id: action.selected_template_id };
            //console.log(state);
            return state;

        case actions.EmailMessageTemplateActionTypes.ADD_EMAIL_MESSAGE_TEMPLATE:
            return templateAdapter.addOne(action.template, state);

        case actions.EmailMessageTemplateActionTypes.ADD_EMAIL_MESSAGE_TEMPLATES:
            return templateAdapter.addMany(action.templates, state);

        case actions.EmailMessageTemplateActionTypes.UPSERT_EMAIL_MESSAGE_TEMPLATE:
            return templateAdapter.upsertOne(action.template, state);

        case actions.EmailMessageTemplateActionTypes.UPSERT_EMAIL_MESSAGE_TEMPLATES:
            return templateAdapter.upsertMany(action.templates, state);

        case actions.EmailMessageTemplateActionTypes.UPDATE_EMAIL_MESSAGE_TEMPLATE:
            return templateAdapter.updateOne(action.template, state);

        case actions.EmailMessageTemplateActionTypes.UPDATE_EMAIL_MESSAGE_TEMPLATES:
            return templateAdapter.updateMany(action.templates, state);

        case actions.EmailMessageTemplateActionTypes.DELETE_EMAIL_MESSAGE_TEMPLATE:
            return templateAdapter.removeOne(action.template_id, state);

        case actions.EmailMessageTemplateActionTypes.DELETE_EMAIL_MESSAGE_TEMPLATES:
            return templateAdapter.removeMany(action.template_ids, state);

        case actions.EmailMessageTemplateActionTypes.DELETE_ALL_EMAIL_MESSAGE_TEMPLATES:
            return templateAdapter.removeMany(action.template_ids, state);

        case actions.EmailMessageTemplateActionTypes.DELETE_ALL:
            return templateAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getEmailMessageTemplateState = createFeatureSelector<EmailMessageTemplateState>('emailMessageTemplate');

export const { selectIds, selectEntities, selectAll, selectTotal } = templateAdapter.getSelectors(getEmailMessageTemplateState);

const getSelectedTemplateIdState = (state: EmailMessageTemplateState) => {
    return state.selected_template_id;
};
export const getSelectedTemplateId = createSelector(getEmailMessageTemplateState, getSelectedTemplateIdState);

export const getSelectedTemplate = createSelector(getEmailMessageTemplateState, (state: EmailMessageTemplateState) => {
    if (state.selected_template_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_template_id];
});
